import React from "react";
import { Icon as IconType } from "@/types/icon";
import Icon from "@/components/common/Icon";
import { generateLicenseLink } from "@/utils/links";
import { useEscSuppressibleTooltip } from "@/hooks/use-esc-suppressible-tooltip";

interface Props {
  icon: IconType;
  linkTarget: string;
  licenseKey: string;
  locale: string;
  slug: string;
}

export default function LicenseCell({
  icon,
  linkTarget,
  licenseKey,
  locale,
  slug,
}: Props) {
  const licenseUrl = generateLicenseLink(licenseKey, locale, slug);
  const tooltip = useEscSuppressibleTooltip();
  const isLink = licenseUrl !== "#";
  const label = [icon.name, icon.description?.trim()]
    .filter(Boolean)
    .join(" – ");

  return (
    <a
      ref={tooltip.setTriggerRef}
      aria-label={label}
      className={`tooltip min-h-[44px] min-w-[44px] ${
        isLink ? "clickable-icon-cell" : ""
      } ${tooltip.isSuppressed ? "tooltip-escape-hidden" : ""}`}
      href={licenseUrl}
      target={isLink ? linkTarget : undefined}
      onKeyDown={tooltip.onKeyDown}
      onBlur={tooltip.resetSuppressed}
      onMouseLeave={tooltip.resetSuppressed}
    >
      <span className="icon-tt">
        <Icon
          icon={icon}
          width={110}
          height={60}
          showArrow={licenseUrl !== "#"}
          alt={[icon.name, icon.description?.trim()].filter(Boolean).join(" – ")}
        />
        <span className="tooltiptext" aria-hidden="true">
          {icon.description?.trim()}
        </span>
      </span>
    </a>
  );
}
